import { AxiosError } from 'axios';

/**
 * 서버로부터 쓸 만한 응답을 받지 못한 상황인지 판별한다.
 * 참이면 안내 화면(조회) 또는 토스트(제출)로 알린다.
 *
 * 두 가지를 모두 포함한다.
 *
 * 1) 5xx 응답 — 서버가 응답은 했지만 실패한 경우
 * 2) **응답 자체가 없는 경우** — 여기가 핵심이다.
 *
 * 2번을 빼면 정작 배포 중 다운타임을 못 잡는다. CORS 허용 헤더를 Spring 앱이
 * 붙이는데(WebConfig.addCorsMappings), 앱이 죽어 있으면 ALB 가 대신 502 를 내면서
 * 그 헤더가 빠진다. 브라우저는 헤더 없는 교차출처 응답을 차단하므로 JS 에는
 * 502 라는 상태 코드가 **아예 보이지 않고** 네트워크 에러로만 도달한다.
 * 즉 status 로 5xx 를 판별하려는 시도는 이 상황에서 절대 성립하지 않는다.
 * (2026-08-01 dev 재배포로 실측 확인: 안내 화면 대신 "No results found" 가 떴다)
 *
 * 사용자 인터넷이 끊긴 경우도 2번에 걸리는데, 그래도 무방하다. 쿼리는 React Query 가
 * 3회 재시도한 뒤에야 이 판정에 도달하므로, 그 시점이면 실제로 서버에 닿지 못하는
 * 상태가 맞고 사용자에게도 알려야 한다.
 *
 * 취소된 요청은 제외한다 — 화면 이탈 등으로 스스로 끊은 것이라 장애가 아니다.
 */
export const isServerUnavailable = (error: unknown): boolean => {
  if (!(error instanceof AxiosError)) return false;
  if (error.code === AxiosError.ERR_CANCELED) return false;

  // 응답을 못 받았으면 status 가 비어 있다(CORS 차단·네트워크 단절·타임아웃).
  return error.status == null || error.status >= 500;
};
